"use client";
import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import styles from "./WhatsNewModal.module.css";

interface WhatsNewModalProps {
  visible: boolean;
  onClose: () => void;
  onOk: () => void;
}

const WhatsNewModal: React.FC<WhatsNewModalProps> = ({
  visible,
  onClose,
  onOk,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      maskClosable={false}
      width={800}
      className={styles.whatsNewModal}
      centered
      style={{
        borderRadius: "12px",
      }}
    >
      <div className={styles.modalContent}>
        {/* Close button */}
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          <CloseOutlined />
        </button>

        {/* Title */}
        <h2 className={styles.title}>What's New on Trek?</h2>

        {/* Content */}
        <p className={styles.content}>
          We've upgraded our upload functionality! Add files to a collection using the + icon in the chatbot. Once uploaded, head to Library to pull your collection into any chat session and start querying.
        </p>

        {/* OK Button */}
        <div className={styles.buttonContainer}>
          <button className={styles.okButton} onClick={onOk}>
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WhatsNewModal;

